import * as React from "react";
import { ErrorPage } from "./ErrorPage";
export const MobileVersionErrorView = () => {
    return (React.createElement(ErrorPage, { message: `The current version of the mobile app you are on ${window.MOBILE_APP_VERSION} is no longer supported. Please update from the app store.` }));
};
